// extracted by mini-css-extract-plugin
export default {"privacyPolicyBlock":"PrivacyPolicy_privacyPolicyBlock__gcPjQ"};